import { Hub } from 'aws-amplify/utils'

import { Severity } from '../components/molecules/NotificationPopUp'

export const notificationChannelName = 'notification-popup'

export const showMessage = (message: string, severity?: Severity) => {
    Hub.dispatch(notificationChannelName, {
        event: 'message',
        data: {
            message,
            severity: severity || 'info'
        }
    })
}

export const showBusy = (busy: boolean) => {
    Hub.dispatch(notificationChannelName, {
        event: 'busy',
        data: {
            busy,
        }
    })
}
